$(function () {
  'use strict';
  //
  //Extension
  //

  var url = '';

  $.ui.autocomplete.prototype._renderItem = function (ul, item) {
    return $('<li></li>').data('item.autocomplete', item).append($('<a></a>').html(item.label)).appendTo(ul);
  };

  $.ui.autocomplete.prototype._resizeMenu = function () {
    var ul = this.menu.element;
    ul.outerWidth(this.element.outerWidth());
  };

  $(document).on('keydown.autocomplete', '.js-search-master', function () {
    var profileForm = $(this).closest('.search-master-form');
    $(this).autocomplete({
      autoFocus: false,
      delay: 300,
      minLength: 1,

      source: function (request, response) {
        profileForm.find('.js-master-background-image').css('background-image', 'url("/images/default-profile-image.png")');
        if (!request.term) {
          $(this).attr('autocomplete', 'off');
        }
        $.get('/master_keywords.json', {keyword: request.term}, function (data) {
          response(data.map(function (value) {
            url = value.image_url;
            return {
              label: value.name,
              value: value.name,
              url: value.image_url
            };
          }));
        });
      },

      create: function () {
        // aware tap twice (double tap) on iOS
        if (navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/Android/)) {
          $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
        }

        $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
          return $('<li data-value="' + item.value + '">' + item.label + '</li>').appendTo(ul);
        };
      },

      select: function (event, ui) {
        profileForm.find('.js-master-background-image').css('background-image', 'url(' + ui.item.url + ')');
      }
    });
  });
});
